import React from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';
import { ShoppingCart } from 'lucide-react';
import { NETFLIX_COLORS, NETFLIX_SPACING } from '../theme/netflixTheme';
import { isPaymentFirstFlow } from '../config/authFlow';
import { useAuth } from '../contexts/AuthContext';

interface BuyButtonProps {
  onPress: () => void;
  variant?: 'primary' | 'secondary' | 'minimal';
  size?: 'small' | 'medium' | 'large';
}

export function BuyButton({ onPress, variant = 'primary', size = 'medium' }: BuyButtonProps) {
  const { isAuthenticated } = useAuth();

  // Only show buy button everywhere if payment_first flow
  // Otherwise only show if authenticated
  if (!isPaymentFirstFlow() && !isAuthenticated) {
    return null;
  }

  return (
    <Pressable onPress={onPress} style={[styles.button, styles[variant], styles[size]]}>
      <ShoppingCart size={size === 'small' ? 16 : size === 'medium' ? 20 : 24} color={NETFLIX_COLORS.white} />
      <Text style={styles.buttonText}>Comprar</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: NETFLIX_SPACING.sm,
    paddingVertical: NETFLIX_SPACING.md,
    paddingHorizontal: NETFLIX_SPACING.lg,
    borderRadius: 6,
  },
  primary: {
    backgroundColor: NETFLIX_COLORS.primary,
  },
  secondary: {
    backgroundColor: NETFLIX_COLORS.surface,
    borderWidth: 1,
    borderColor: NETFLIX_COLORS.border,
  },
  minimal: {
    backgroundColor: 'transparent',
  },
  small: {
    paddingVertical: NETFLIX_SPACING.sm,
    paddingHorizontal: NETFLIX_SPACING.md,
  },
  medium: {
    paddingVertical: NETFLIX_SPACING.md,
    paddingHorizontal: NETFLIX_SPACING.lg,
  },
  large: {
    paddingVertical: NETFLIX_SPACING.lg,
    paddingHorizontal: NETFLIX_SPACING.xl,
  },
  buttonText: {
    color: NETFLIX_COLORS.white,
    fontSize: 14,
    fontWeight: '600',
  },
});
